import logPerformanceDatapoint from '../helpers/logPerformanceDatapoint';
import addResourceTimingEntryMutator from '../mutators/addResourceTimingEntryMutator';
import { ResourceTimingEntry, SearchRequestInstrumentation } from 'owa-search-service';
import { PerformanceDatapoint } from 'owa-analytics';

export default function addResourceTimingEntry(
    resourceTimingEntry: ResourceTimingEntry,
    searchInstrumentationEntry: SearchRequestInstrumentation,
    executeSearchDatapoint: PerformanceDatapoint
) {
    // Add resource timing entry to store
    addResourceTimingEntryMutator(
        searchInstrumentationEntry,
        resourceTimingEntry,
        executeSearchDatapoint
    );

    // Trigger logging of datapoint now that the data is complete
    logPerformanceDatapoint(searchInstrumentationEntry);
}
